export default class NumberFormatter {
    static numberWithSpaces(x) {
        if (!x && x !== 0) {
            return "";
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    static numberRoundedWithSpaces(x, decimals = 1) {
        if (!x && x !== 0) {
            return "";
        }
        return x.toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    static numberWithOneDecAndProcent(x) {
        if (!x)
            return "";
        x = (x * 100).toFixed(2)
        return (x).toString() + '%' 
    }

    static numberWithOneDec(num) {
        if (!num)
            return "";
        const rounded = parseFloat(num.toFixed(1));
        return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(1);    }

    static numberAsPercent(x) {
        if (!x)
            return "";
        x = (x * 100).toFixed(0)
        return (x).toString() + '%' 
    }

    static roundContactsAsInPopAPI(x) {
        if (x <= 0) {
            return 0;
        }
        const log10 = Math.floor(Math.log(x) / Math.log(10));
        if (log10 > 2) {
            const p10 = Math.pow(10, log10 - 2);
            const res = Math.floor((x + p10 / 2) / p10) * p10;
            return res;
        } else {
            return x;
        }
    }
}